import React from 'react'

export default function FaceFeature({ scale, verticalOffset = 0 }) {
  const transformOrigin = '22.4 8.1'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-orign={transformOrigin}>
      <path
        d="M19.2701 5.49006C19.7201 9.43006 15.5502 15.9701 8.79015 15.4101C1.23015 14.7801 0.000133514 2.34006 6.99013 1.33006C13.9801 0.310059 18.8901 2.10006 19.2701 5.49006Z"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M25.58 5.49006C25.13 9.43006 29.3 15.9701 36.06 15.4101C43.62 14.7801 44.85 2.34006 37.86 1.33006C30.88 0.310059 25.97 2.10006 25.58 5.49006Z"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M34.0301 0.530029C29.7001 0.530029 25.2601 1.69001 22.4201 1.76001C19.5801 1.69001 15.1501 0.530029 10.8101 0.530029C2.47006 0.530029 0.560059 3.01001 0.560059 3.01001V5.60004C1.57006 6.28004 1.99005 7.63004 1.99005 7.63004C1.99005 3.57004 5.21007 1.47001 9.82007 1.45001C11.3601 1.44001 13.2101 1.52003 14.9801 2.03003C22.0801 4.06003 18.7701 9.65002 18.7701 9.65002C18.7701 9.65002 20.16 7.96001 20.61 6.95001C21.06 5.94001 19.6001 4.13003 19.6001 3.34003C19.6001 2.79003 21.1801 2.55002 22.4201 2.55002C23.6601 2.55002 25.2401 2.78003 25.2401 3.34003C25.2401 4.13003 23.7801 5.93001 24.2301 6.95001C24.6801 7.96001 26.0701 9.65002 26.0701 9.65002C26.0701 9.65002 22.77 4.05003 29.86 2.03003C31.78 1.48003 33.6001 1.41003 35.2301 1.47003C39.6401 1.63003 42.8501 3.74004 42.8501 7.63004C42.8501 7.63004 43.2601 6.28004 44.2801 5.60004V3.01001C44.2901 3.01001 42.3701 0.530029 34.0301 0.530029Z"
        fill="#77370B"
      />
    </g>
  )
}
